import styles from "./DatePicker.module.scss";
import React, {useEffect, useMemo, useState} from "react";
import moment from "moment";
import clsx from "clsx";

export const DatePicker = ({value, onChange}) => {
  const [currentValue, setCurrentValue] = useState(() => value ? moment(value) : moment());
  const [calendarDate, setCalendarDate] = useState(() => (value ? moment(value) : moment()).startOf("month"));

  useEffect(() => {
    if (!value || currentValue.format("YYYY-MM-DD") === value) {
      return;
    }

    setCurrentValue(moment(value));
    setCalendarDate(moment(value).startOf("month"));
  }, [currentValue, value]);

  const now = moment();

  const days = useMemo(() => {
    const d = [];

    const currentDate = calendarDate.clone().startOf("isoWeek");

    for (let i = 0; i < 42; i++) {
      d.push(currentDate.clone());

      currentDate.add(1, "day");
    }

    return d;
  }, [calendarDate]);

  const chooseDate = date => () => {
    setCurrentValue(date);

    onChange(date.format("YYYY-MM-DD"));
  };

  return <div className={styles.datePicker}>
    <div className={styles.currentValue}
         onClick={() => setCalendarDate(currentValue.clone().startOf("month"))}>{currentValue.format("DD MMMM YYYY")}</div>
    <div className={styles.navigator}>
      <div className={styles.navigatorItem}>
        <span className={clsx("material-icons", styles.left)}
              onClick={() => setCalendarDate(calendarDate.clone().subtract(1, "month"))}>chevron_left</span>
        <span className={styles.navigatorValue}>{calendarDate.format("MMM")}</span>
        <span className={clsx("material-icons", styles.right)}
              onClick={() => setCalendarDate(calendarDate.clone().add(1, "month"))}>chevron_right</span>
      </div>

      <div className={styles.navigatorItem}>
        <span className={clsx("material-icons", styles.left)}
              onClick={() => setCalendarDate(calendarDate.clone().subtract(1, "year"))}>chevron_left</span>
        <span className={styles.navigatorValue}>{calendarDate.format("YYYY")}</span>
        <span className={clsx("material-icons", styles.right)}
              onClick={() => setCalendarDate(calendarDate.clone().add(1, "year"))}>chevron_right</span>
      </div>
    </div>
    <div className={styles.days}>
      {(days || []).map(d => {
        const classes = [styles.day];

        if (d.isSame(currentValue, "day")) {
          classes.push(styles.active);
        } else if (d.isSame(now, "day")) {
          classes.push(styles.today);
        } else if (d.get("month") !== calendarDate.get("month")) {
          classes.push(styles.otherMonth);
        }

        let dateFormatted = d.format("YYYY/MM/DD");

        return <div key={dateFormatted} className={clsx(classes)} onClick={chooseDate(d)}>{d.format("D")}</div>;
      })}
    </div>
  </div>;
};
